import React, { useContext, useEffect, useState } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import { IoSearchSharp, IoNewspaperOutline } from 'react-icons/io5';
import { BiSolidEditAlt } from 'react-icons/bi';
import { CiEdit } from 'react-icons/ci';
import { LuDelete } from 'react-icons/lu';
import { TiDeleteOutline, TiTick } from 'react-icons/ti';
import { FaRegWindowClose, FaUserEdit } from 'react-icons/fa';
import { DataContext } from '../context/DataProvider';
import { Link, useSearchParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { RiLockPasswordLine, RiShieldKeyholeLine } from 'react-icons/ri';
import axios from 'axios';
import e from 'express';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { addDays, format as jalaliFormat, set } from 'date-fns-jalali';
import { PiUserListBold } from 'react-icons/pi';
import Select from 'react-dropdown-select';
import { LiaUserAstronautSolid } from 'react-icons/lia';
import Cookies from 'js-cookie';
// import delete from '../images/icons/delete.png'
const UsersManagment = () => {
  const {
    userInfo,
    expire,
    expireToken,
    tokenLogin,
    fetchRefreshToken,
    isTokenExpired,
    edame,
    OptionSearch,
    setOption,
    Register,
    username,
    setUserName,
    currentuserCookie,
    setCurrentUserCookie,
    CookieToken,
    setCookieToken,
    GetRolesList,
    Roles,
    setRoles,
    NewfetchRefreshToken,
  }: any = useContext(DataContext);
  const [searchParams, setsearchParams] = useSearchParams();
  const page: any = searchParams.get('page');
  const [UserList, setUserList] = useState([]);
  // const [IsActioveUser, setIsActioveUser] = useState(null);
  const [PermissionList, setPermissionList] = useState([]);
  const [PermissionsSelect, setPermissionsSelect] = useState([]);
  const [UserRolesList, setUserRolesList] = useState([]);
  // const [lisUsercutorcount, setLisUsercutorcount] = useState(0);
  const [searchOption, setSearchOption] = useState({
    userName: '',
    firstName: '',
    lastName: '',
    gender: 0,
    nationalCode: '',
  });
  const [editcase, setEditCase] = useState({
    firstName: '',
    lastName: '',
    ID: 0,
    email: '',
    phoneNumber: '',
    nationalCode: '',
    birthDay: '',
    gender: 0,
    roles: [],
    Password: '',
    confirmPassword: '',
    userName: '',

    // role: '',
    // education: '',
    // degree: '',
    // place: '',
  });
  const [pageSize, setPageSize] = useState(10);
  let rowNumber = page ? (page - 1) * pageSize : 0;

  const [UserRole, setUserRole] = useState('');
  // const [isLoading, setisLoading] = useState(true);
  const [openModal, setOpenModal] = useState({
    ShowPermissionsSelect: false,
  });
  const [EditModal, setOpenEditModal] = useState(false);
  const [CreateModal, setOpenCreateModal] = useState(false);
  const [UserPermissionListModal, setUserPermissionListModal] = useState(false);
  const [UserRolesListModal, setUserRolesListModal] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [userByID, setUserByID] = useState({});
  const [savePage, setSavePage] = useState(1);
  const [OpenAddNewRole, setOpenAddNewRole] = useState(false);
  const [userInfoForRole, setUserInfoForRole] = useState({
    UserName: '',
    UserID: 0,
    userRoles: [],
    isActive: true,
  });
  const FetchListUser = async () => {
    let config = {
      method: 'post',
      // maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/User/UserList`,
      // url: `${process.env.REACT_APP_BASE_URL}/v1/User/UserList`,
      headers: {
        // Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        Authorization: `Bearer ${tokenLogin?.data.accessToken}`,

        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        filters: {
          pageNumber: page === null ? 1 : page,
          pageSize: pageSize,
          isSortAscending: false,
          sortField: '',
          search: '',
        },
        userName: searchOption.userName !== '' ? searchOption.userName : '',
        firstName: searchOption.firstName !== '' ? searchOption.firstName : '',
        lastName: searchOption.lastName !== '' ? searchOption.lastName : '',
        gender: searchOption.gender !== 0 ? searchOption.gender : null,
        nationalCode:
          searchOption.nationalCode !== '' ? searchOption.nationalCode : '',
        isActive: null,
      }),
    };
    try {
      axios.request(config).then((res) => {
        const list = res.data;
        console.log(res.data);
        setUserList(list.data.items);
        setPageCount(list.data.totalItems);
      });
    } catch (error) {}
  };
  const FindUserByID = (userID: number) => {
    let config = {
      method: 'post',
      // maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/User/GetUserById`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/User/GetUserById`,
      headers: {
        // Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        Authorization: `Bearer ${tokenLogin?.data.accessToken}`,

        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        id: userID,
      }),
    };
    try {
      axios.request(config).then((res) => {
        const list = res.data;
        // console.log(list);
        setUserByID(list.data);
        setOpenEditModal(true);
      });
    } catch (error) {}
  };
  console.log(userByID);
  const ChangeUserStateFun = (e, username) => {
    let config = {
      method: 'post',
      // maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/User/ChangeUserStatus`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/User/ChangeUserStatus`,
      headers: {
        // Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        Authorization: `Bearer ${tokenLogin?.data.accessToken}`,

        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        userName: username,
        active: e.target.value === 'true' ? true : false,
      }),
    };
    if (isTokenExpired(CookieToken.accessToken)) {
      NewfetchRefreshToken();
    } else {
      try {
        axios.request(config).then((res) => {
          const list = res.data;
          // console.log(list);
          alert(`${list.message}`);
          FetchListUser();
        });
      } catch (error) {}
    }
  };
  const ChangeDate = (date: {}) => {
    const dateString = new Date(date);
    console.log(dateString);
    const formattedDate = dateString.toISOString();
    setEditCase((prev) => ({
      ...prev,
      birthDay: formattedDate,
    }));
  };
  const EditUserInformation = () => {
    console.log(editcase);
    let config = {
      method: 'post',
      // maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/User/EditUser`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/User/EditUser`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,

        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        firstName:
          editcase.firstName !== '' ? editcase.firstName : userByID.firstName,
        lastName:
          editcase.lastName !== '' ? editcase.lastName : userByID.lastName,
        birthDay:
          editcase.birthDay !== '' ? editcase.birthDay : userByID.birthDay,
        genderType:
          editcase.gender !== 0 ? editcase.gender : userByID.genderType,
        nationalCode:
          editcase.nationalCode !== ''
            ? editcase.nationalCode
            : userByID.nationalCode,
        phoneNumber:
          editcase.phoneNumber !== ''
            ? editcase.phoneNumber
            : userByID.phoneNumber,
        email: editcase.email !== '' ? editcase.email : userByID.email,
      }),
    };
    if (isTokenExpired(CookieToken.accessToken)) {
      NewfetchRefreshToken();
    } else {
      try {
        axios.request(config).then((res) => {
          const list = res.data;
          console.log(list);
          FetchListUser();
          setOpenEditModal(false);
          alert(`${list.message}`);
        });
      } catch (error) {}
    }
  };
  const handleChangeSelect = (value) => {
    let arr = [];
    value.forEach((element) => {
      arr.push(element.name);
    });
    setEditCase((prev) => ({ ...prev, roles: arr }));
  };
  // permission api
  const FetchPermissionList = async (userID:number) => {
    setUserInfoForRole((prev) => ({ ...prev, UserID: userID }));
    let config = {
      method: 'post',
      // maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/UserPermission/GetUserPermissionList`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/UserPermission/GetUserPermissionList`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        filters: {
          pageNumber: 1,
          pageSize: 10,
          isSortAscending: true,
          sortField: '',
          search: '',
        },
        userId: userID,
        claimType: '',
        claimValue: '',
        description: '',
        isActivePermission: false,
        isActiveUserPermission: false,
      }),
    };
    try {
      axios.request(config).then((res) => {
        const list = res.data;
        console.log('userPermision', list);
        setPermissionList(list.data.items);
        setUserPermissionListModal(true);
      });
    } catch (error) {}
  };
  const GetPermissionList = () => {
    let config = {
      method: 'post',
      // url: `${process.env.REACT_APP_BASE_URL}/api/User/ChangeUserStatus`,
      url: `${process.env.REACT_APP_BASE_URL}/api/Permission/PermissionList`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        filters: {
          pageNumber: page == null ? 1 : page,
          pageSize: 200,
          isSortAscending: true,
          sortField: '',
          search: '',
        },
        id: 0,
        projectName: '',
        claimType: '',
        claimValue: '',
        description: '',
        isActive: null,
      }),
    };
    try {
      axios.request(config).then((res) => {
        const list = res.data;
        console.log(list);
        setPermissionsSelect(list.data.items);
        // setPermissionCount(list.data.totalItems);
        // setRoleByID(list.data);
      });
    } catch (error) {}
  };
  const AddPermissionToUser = (e: any) => {
    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/api/UserPermission/AddUserPermission`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/UserPermission/AddPermissionToUser`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        userId: userInfoForRole.UserID,
        permissionId: Number(e.target.value),
      }),
    };
    try {
      axios.request(config).then((res) => {
        const list = res.data;
        console.log(list);
        if (list.message == '') {
          alert(`${list.data.message}`);
          FetchPermissionList(userInfoForRole.UserID);
        } else {
          alert(`${list.message}`);
        }
      });
    } catch (error) {}
  };
  const RemovePermissionFromUser = (permissionID: string) => {
    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/api/UserPermission/RemovePermissionFromUser`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/UserPermission/RemovePermissionFromUser`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        userId: userInfoForRole.UserID,
        permissionId: permissionID,
      }),
    };
    try {
      axios.request(config).then((res) => {
        const list = res.data;
        console.log(list);
        if (list.message == '') {
          alert(`${list.data.message}`);
          FetchPermissionList(userInfoForRole.UserID);
        } else {
          alert(`${list.message}`);
        }
      });
    } catch (error) {}
  };

  const ChangeUserPermissionStatus = (e: any, permissionID: string) => {
    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/api/UserPermission/ChangeUserPermissionStatus`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/UserPermission/ChangeUserPermissionStatus`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        permissionId: permissionID,
        userId: userInfoForRole.UserID,
        isActive: e.target.value == 'true' ? true : false,
      }),
    };
    try {
      axios.request(config).then((res) => {
        const list = res.data;
        console.log(list);
        if (list.message == '') {
          alert(`${list.data.message}`);
          FetchPermissionList(userInfoForRole.UserID);
        } else {
          alert(`${list.message}`);
        }
      });
    } catch (error) {}
  };
  // user Roles api
  const AddRoleToUserFun = () => {
    let config = {
      method: 'post',
      // maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/User/AddRoleToUser`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/User/AddRoleToUser`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        userName: userInfoForRole.UserName,
        roleName: UserRole,
      }),
    };
    if (isTokenExpired(CookieToken.accessToken)) {
      NewfetchRefreshToken();
    } else {
      try {
        axios.request(config).then((res) => {
          const list = res.data;
          console.log('ChangeUserRole', list);
          alert(`${list.message}`);
          FetchUserRoles(userInfoForRole.UserID, userInfoForRole.UserName);
          // setPermissionList(list.data);
        });
      } catch (error) {}
    }
  };
  const RemoverRoleFromUser = (roleName) => {
    let config = {
      method: 'post',
      // maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/User/RemoveRoleFromUser`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/User/RemoveRoleFromUser`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        userName: userInfoForRole.UserName,
        roleName: roleName,
      }),
    };
    if (isTokenExpired(CookieToken.accessToken)) {
      NewfetchRefreshToken();
    } else {
      try {
        axios.request(config).then((res) => {
          const list = res.data;
          console.log('ChangeUserRole', list);
          alert(`${list.message}`);
          FetchUserRoles(userInfoForRole.UserID, userInfoForRole.UserName);
          // setPermissionList(list.data);
        });
      } catch (error) {}
    }
  };
  const FetchUserRoles = (userID: number, username: string) => {
    setUserInfoForRole((prev) => ({
      ...prev,
      UserID: userID,
      UserName: username,
    }));
    let config = {
      method: 'post',
      // maxBodyLength: Infinity,
      // url: `${process.env.REACT_APP_BASE_URL}/api/UserPermission/GetUserPermissionList`,
      url: `${process.env.REACT_APP_BASE_URL}/api/User/GetUserRolesById`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        id: userID,
      }),
    };
    try {
      axios.request(config).then((res) => {
        const list = res.data;
        console.log('userROles', list);
        setUserRolesList(list.data);

        setUserRolesListModal(true);
      });
    } catch (error) {}
  };

  useEffect(() => {
    FetchListUser();
    GetRolesList();
  }, [pageSize, page]);
  const onChagngePageSearchResult = (data: any) => {
    setsearchParams({ page: data.selected + 1 });
    setSavePage(data.selected + 1);
  };
  const CreateUserWithRole = () => {
    let config = {
      method: 'post',
      // maxBodyLength: Infinity,
      // url: `${process.env.REACT_APP_BASE_URL}/api/User/AddRoleToUser`,
      url: `${process.env.REACT_APP_BASE_URL}/api/User/InsertUserWithRoles`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,

        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        firstName: editcase.firstName,
        lastName: editcase.lastName,
        birthDay: editcase.birthDay,
        genderType: editcase.gender,
        nationalCode: editcase.nationalCode,
        phoneNumber: editcase.phoneNumber,
        email: editcase.email,
        userName: editcase.userName,
        password: editcase.Password,
        confirmPassword: editcase.confirmPassword,
        isActive: true,
        roles: editcase.roles,
      }),
    };
    if (isTokenExpired(CookieToken.accessToken)) {
      NewfetchRefreshToken();
    } else {
      try {
        axios.request(config).then((res) => {
          const list = res.data;
          console.log('createUSer', list);
          alert(`${list.message}`);
          // setPermissionList(list.data);
        });
      } catch (error) {}
    }
  };

  if (tokenLogin == '') {
    window.location.assign('/');
    localStorage.clear();
    Cookies.remove('token');
  }
  return (
    <>
      <Breadcrumb pageName="مدیریت کاربران" />
      <div className="w-full max-w-full font-IranSans p-10 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="w-full flex items-center justify-between">
          <div className="w-full flex items-center gap-3">
            <input
              className="w-46 focus:outline-none border p-2 rounded-lg"
              placeholder="نام کاربر"
              onChange={(e) =>
                setSearchOption({ ...searchOption, firstName: e.target.value })
              }
            />
            <input
              className="w-46 focus:outline-none border p-2 rounded-lg"
              placeholder="نام خانوادگی کاربر"
              onChange={(e) =>
                setSearchOption({ ...searchOption, lastName: e.target.value })
              }
            />
            <input
              className="w-46 focus:outline-none border p-2 rounded-lg"
              placeholder="نام کاربری"
              onChange={(e) =>
                setSearchOption({ ...searchOption, userName: e.target.value })
              }
            />
            <input
              className="w-46 focus:outline-none border p-2 rounded-lg"
              placeholder="کد ملی"
              onChange={(e) =>
                setSearchOption({
                  ...searchOption,
                  nationalCode: e.target.value,
                })
              }
            />
            <select
              onChange={(e) =>
                setSearchOption({
                  ...searchOption,
                  gender: Number(e.target.value),
                })
              }
              className="w-46 focus:outline-none border p-2 rounded-lg"
            >
              <option value="0">ناشناس</option>
              <option value="1">زن</option>
              <option value="2">مرد</option>
            </select>
            <button onClick={FetchListUser} className="buttonsearch">
              <IoSearchSharp size={35} className="svgIcon" />
            </button>
          </div>

          <div>
            <button
              className=" w-full md:mt-0 mt-3 "
              onClick={() => setOpenCreateModal(true)}
            >
              <span className="boxUSer font-IranSans text-[16px] w-full">
                {' '}
                کاربر جدید
              </span>
            </button>
          </div>
        </div>
        <div className="w-full  overflow-y-auto">
          <table className="overflow-auto w-full">
            <thead>
              <tr className="font-IranSans w-full bg-[#B1B2FF] text-[#030637]">
                <th className="w-20 border-b p-3 text-[14px] text-center">
                  نام و نام خانوادگی
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  نام کاربری
                </th>
                <th className="w-20 border-b p-3 text-[14px] text-center">
                  ایمیل
                </th>
                <th className="w-20 border-b p-3 text-[14px] text-center">
                  کد ملی
                </th>
                <th className="w-20 border-b p-3 text-[14px] text-center">
                  شماره همراه
                </th>
                {/* <th className="w-32 border-b p-3 text-[14px] text-center">
                  تحصیلات و مدرک تحصیلی
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  نقش کاربری
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  محل خدمت{' '}
                </th> */}

                <th className="w-10 border-b p-3 text-[14px] text-center">
                  وضعیت کاربر{' '}
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  نقش کاربری
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  مجوز های کاربر{' '}
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  ویرایش{' '}
                </th>
              </tr>
            </thead>
            <tbody>
              {UserList.map((item) => {
                return (
                  <>
                    <tr
                      className="cursor-pointer w-full"
                      // onClick={() => FindUserByID(item.id)}
                    >
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {item.firstName + '  ' + item.lastName}
                      </td>
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {item.userName}
                      </td>
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {item.email}
                      </td>
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {item.nationalCode}
                      </td>{' '}
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {item.phoneNumber}
                      </td>{' '}
                      {/* <td className="w-20 border-b p-3 text-[14px] text-center">
                        {item.Email}
                      </td>{' '}
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {item.Email}
                      </td>
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {item.Email}
                      </td> */}
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        <select
                          onChange={(e) => ChangeUserStateFun(e, item.userName)}
                          className="w-full border p-1 rounded-md"
                        >
                          <option value={null}></option>
                          {item.isActive ? (
                            <option selected value={true}>
                              فعال
                            </option>
                          ) : (
                            <option value={true}>فعال</option>
                          )}{' '}
                          {!item.isActive ? (
                            <option selected value={false}>
                              غیر فعال
                            </option>
                          ) : (
                            <option value={false}>غیر فعال</option>
                          )}
                        </select>
                      </td>
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        <span className="w-full flex items-center justify-center">
                          <button
                            className="EditRole-button"
                            onClick={() =>
                              FetchUserRoles(item.id, item.userName)
                            }
                          >
                            <LiaUserAstronautSolid
                              size={35}
                              className="EditRole-svgIcon"
                            />
                          </button>
                        </span>
                      </td>
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        <span className="w-full flex items-center justify-center">
                          <button
                            className="Permission-button"
                            onClick={() => FetchPermissionList(item.id)}
                          >
                            <PiUserListBold
                              size={35}
                              className="Permission-svgIcon"
                            />
                          </button>
                        </span>
                      </td>
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        <span className="w-full flex items-center justify-center">
                          <button
                            className="edit-button"
                            onClick={() => FindUserByID(item.id)}
                          >
                            <BiSolidEditAlt
                              size={35}
                              className="edit-svgIcon"
                            />
                          </button>
                        </span>
                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </table>
        </div>
        <ReactPaginate
          breakLabel={<span className="mr-4 sm:mr-0">...</span>}
          nextLabel={
            <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-1">
              <BsChevronLeft />
            </span>
          }
          onPageChange={onChagngePageSearchResult}
          pageRangeDisplayed={5}
          // pageCount={5}
          pageCount={Math.ceil(pageCount / pageSize)}
          previousLabel={
            <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
              <BsChevronRight />
            </span>
          }
          // initialPage={savePage - 1}
          containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
          pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
          activeClassName={
            savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
          }
          // current
        />
        {EditModal && (
          <div className="ModalBackground">
            <div className="Modal-innerEditUser">
              <FaRegWindowClose
                onClick={() => setOpenEditModal(false)}
                className="mb-2"
                size={20}
              />
              <div className="w-full py-2 rounded-md border border-[#9ca3af] grid grid-cols-1 gap-3 px-3">
                <div className="w-full flex  items-center ">
                  <span className="w-[30%]">نام و نام خانوادگی:</span>
                  <input
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                    defaultValue={userByID.firstName}
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        firstName: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="w-full flex  items-center ">
                  <span className="w-[30%]"> نام خانوادگی:</span>
                  <input
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                    defaultValue={userByID.lastName}
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        lastName: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="w-full flex  items-center ">
                  <span className="w-[30%]">تاریخ تولد:</span>
                  <DatePicker
                    className="custom-calendar"
                    inputClass="custom-input"
                    calendarPosition="bottom-center"
                    value={
                      userByID.birthDay !== '' &&
                      jalaliFormat(userByID.birthDay, 'yyyy/MM/dd')
                    }
                    locale={persian_fa}
                    calendar={persian}
                    onChange={ChangeDate}
                  />
                </div>
                <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">جنسیت :</span>
                  <select
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        gender: Number(e.target.value),
                      }))
                    }
                    className="border w-[70%] mr-3 p-1 rounded-md"
                  >
                    {userByID.genderType === 'Unknown'||userByID.genderType === 'null' ? (
                      <option selected value={0}>
                        ناشناس
                      </option>
                    ) : (
                      <option value={0}>ناشناس</option>
                    )}
                    {userByID.genderType === "Female" ? (
                      <option selected value={1}>
                        زن
                      </option>
                    ) : (
                      <option value={1}>زن</option>
                    )}
                    {userByID.genderType === 'Male' ? (
                      <option selected value={2}>
                        مرد
                      </option>
                    ) : (
                      <option value={2}>مرد</option>
                    )}
                  </select>
                </div>
                {/* <div className="w-full flex  items-center ">
                  <span className="w-[30%]">نام کاربری:</span>
                  <input
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                    defaultValue={userByID.userName}
                    onChange={(e) =>
                      setEditCase({ ...editCase, userName: e.target.value })
                    }
                  />
                </div> */}
                <div className="w-full flex  items-center">
                  <span className="w-[30%]">ایمیل:</span>
                  <input
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                    type="email"
                    defaultValue={userByID.email}
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        email: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="w-full flex  items-center ">
                  <span className="w-[30%]">کدملی:</span>
                  <input
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        nationalCode: e.target.value,
                      }))
                    }
                    defaultValue={userByID.nationalCode}
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                  />
                </div>
                <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">شماره همراه:</span>
                  <input
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        phoneNumber: e.target.value,
                      }))
                    }
                    defaultValue={userByID.phoneNumber}
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                  />
                </div>
                {/* <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">سطح تحصیلات :</span>
                  <select className="border w-[70%] mr-3 p-1 rounded-md">
                    <option></option>
                    <option>کارشناسی</option>
                    <option>کارشناسی ارشد</option>
                    <option>دکتری</option>
                  </select>
                </div> */}
                {/* <div className="w-full flex items-center h-full">
                  <span className="w-[30%]">مدرک تحصیلی :</span>
                  <select className="border w-[70%] mr-3 p-1 rounded-md"></select>
                </div> */}
                {/* <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">نقش کاربری:</span>
                  <select className="border w-[70%] mr-3 p-1 rounded-lg">
                    <option></option>
                    {Roles.map((item, index) => (
                      <option key={item.id}>{item.description}</option>
                    ))}
                  </select>
                </div> */}
                {/* <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">محل خدمت:</span>
                  <input className="border mr-3 w-[70%] p-1 focus:outline-none rounded-lg" />
                </div> */}

                <div className="flex  w-full ltr mt-1 mb-2 gap-3">
                  {/* <button
                  className="w-24 h-10 p-2 rounded-full text-[14px] text-white font-bold
                 bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
                  style={{ fontFamily: 'IranSans' }}
                >
                  حذف
                </button> */}
                  <button
                    className="w-24 h-10 p-2 rounded-full flex items-center justify-center text-[14px] hover:border-2 text-white bg-[#65B741] font-bold 
                  hover:shadow-2xl hover:shadow-black "
                    style={{ fontFamily: 'IranSans' }}
                    onClick={EditUserInformation}
                  >
                    ثبت
                    <CiEdit size={20} className="ml-2" />
                  </button>
                  <Link to="/changepasswordbysuperadmin">
                    <button
                      onClick={() =>
                        localStorage.setItem('username', editcase.Username)
                      }
                      className="w-32 h-10 p-2 rounded-full text-[14px] text-white flex items-center justify-center
                 bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black"
                      style={{ fontFamily: 'IranSans' }}
                      // onClick={fetchEdit}
                    >
                      تغییر رمز عبور <RiLockPasswordLine className="ml-3" />
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
        {CreateModal && (
          <div className="ModalBackground">
            <div className="Modal-innerEditUser">
              <FaRegWindowClose
                onClick={() => setOpenCreateModal(false)}
                className="mb-2"
                size={20}
              />
              <div className="w-full py-4 rounded-md border border-[#9ca3af] grid grid-cols-1 gap-3 px-3">
                <div className="w-full flex  items-center ">
                  <span className="w-[30%]">نام:</span>
                  <input
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        firstName: e.target.value,
                      }))
                    }
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                  />
                </div>
                <div
                  onChange={(e) =>
                    setEditCase((prev) => ({
                      ...prev,
                      lastName: e.target.value,
                    }))
                  }
                  className="w-full flex  items-center "
                >
                  <span className="w-[30%]">نام خانوادگی</span>
                  <input className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md" />
                </div>
                <div className="w-full flex  items-center ">
                  <span className="w-[30%]">تاریخ تولد</span>
                  <DatePicker
                    className="custom-calendar"
                    inputClass="custom-input"
                    calendarPosition="bottom-center"
                    locale={persian_fa}
                    calendar={persian}
                    onChange={ChangeDate}
                  />
                </div>
                <div className="w-full flex  items-center ">
                  <span className="w-[30%]">نام کاربری:</span>
                  <input
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        userName: e.target.value,
                      }))
                    }
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                  />
                </div>
                <div className="w-full flex  items-center">
                  <span className="w-[30%]">ایمیل:</span>
                  <input
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        email: e.target.value,
                      }))
                    }
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                    type="email"
                  />
                </div>
                <div className="w-full flex  items-center ">
                  <span className="w-[30%]">کدملی:</span>
                  <input
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        nationalCode: e.target.value,
                      }))
                    }
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                  />
                </div>
                <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">شماره همراه:</span>
                  <input
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        phoneNumber: e.target.value,
                      }))
                    }
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                  />
                </div>
                <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">جنسیت :</span>
                  <select
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        gender: Number(e.target.value),
                      }))
                    }
                    className="border w-[70%] mr-3 p-1 rounded-md"
                  >
                    <option value={0}>ناشناس</option>
                    <option value={1}>زن</option>
                    <option value={2}>مرد</option>
                  </select>
                </div>
                <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">نقش ها :</span>
                  <div className="w-[70%]">
                    <Select
                      style={{
                        fontFamily: 'IranSans',
                        fontSize: '14px',
                        direction: 'rtl',
                        // height: '30px',
                        width: '100%',
                      }}
                      options={Roles}
                      labelField="description"
                      valueField="name"
                      name="select"
                      multi
                      searchable={true}
                      onChange={handleChangeSelect}
                    />
                  </div>
                  {/* <select className="border w-[70%] mr-3 p-1 rounded-md">
                    {Roles.map((item) => {
                      return (
                        <option value={item.name}>{item.description}</option>
                      );
                    })}
                  </select> */}
                </div>
                <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">رمز عبور:</span>
                  <input
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        Password: e.target.value,
                      }))
                    }
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                  />
                </div>
                <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">تکرار رمز عبور:</span>
                  <input
                    onChange={(e) =>
                      setEditCase((prev) => ({
                        ...prev,
                        confirmPassword: e.target.value,
                      }))
                    }
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                  />
                </div>
                {/* <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">سطح تحصیلات :</span>
                  <select className="border w-[70%] mr-3 p-1 rounded-md">
                    <option></option>
                    <option>کارشناسی</option>
                    <option>کارشناسی ارشد</option>
                    <option>دکتری</option>
                  </select>
                </div> */}
                {/* <div className="w-full flex items-center h-full">
                  <span className="w-[30%]">مدرک تحصیلی :</span>
                  <select className="border w-[70%] mr-3 p-1 rounded-md"></select>
                </div> */}
                {/* <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">نقش کاربری:</span>
                  <select className="border w-[70%] mr-3 p-1 rounded-lg">
                    <option></option>
                    {Roles.map((item, index) => (
                      <option key={item.id}>{item.description}</option>
                    ))}
                  </select>
                </div> */}
                {/* <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">محل خدمت:</span>
                  <input className="border mr-3 w-[70%] p-1 focus:outline-none rounded-lg" />
                </div> */}

                <div className="flex  w-full ltr mt-3 mb-3 gap-3">
                  {/* <button
                  className="w-24 h-10 p-2 rounded-full text-[14px] text-white font-bold
                 bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
                  style={{ fontFamily: 'IranSans' }}
                >
                  حذف
                </button> */}
                  <button
                    className="w-24 h-10 p-2 rounded-full flex items-center justify-center text-[14px] hover:border-2 text-white bg-[#65B741] font-bold 
                  hover:shadow-2xl hover:shadow-black "
                    style={{ fontFamily: 'IranSans' }}
                    onClick={CreateUserWithRole}
                  >
                    ثبت
                    <CiEdit size={20} className="ml-2" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {UserPermissionListModal && (
          <div className="ModalBackground">
            <div className="Modal-innerEditUser">
              <FaRegWindowClose
                onClick={() => setUserPermissionListModal(false)}
                className="mb-2"
                size={20}
              />
              <div className=" h-full">
                {PermissionList.length !== 0 && (
                  <table className="overflow-auto w-full">
                    <thead>
                      <tr className="font-IranSans w-full bg-[#B1B2FF] text-[#030637]">
                        <th className="w-5 border-b p-3 text-[14px] text-center">
                          ردیف
                        </th>
                        <th className="w-10 border-b p-3 text-[14px] text-center">
                          مجوز
                        </th>
                        <th className="w-10 border-b p-3 text-[14px] text-center">
                          توضیحات مجوز
                        </th>{' '}
                        <th className="w-10 border-b p-3 text-[14px] text-center">
                          نام پروژه
                        </th>
                        <th className="w-10 border-b p-3 text-[14px] text-center">
                          وضعیت مجوز
                        </th>
                        <th className="w-10 border-b p-3 text-[14px] text-center">
                          حذف
                        </th>
                        {/* <th className="w-10 border-b p-3 text-[14px] text-center">
                      مجوز های نقش
                    </th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {PermissionList.map((item) => {
                        return (
                          <>
                            <tr className="cursor-pointer w-full">
                              <td className="w-5 border-b p-3 text-[14px] text-center">
                                {(rowNumber = rowNumber + 1)}
                              </td>
                              <td className="w-10 border-b p-3 text-[14px]   text-center">
                                {item.claimValue}
                              </td>
                              <td className=" w-10 border-b p-3 text-[14px]   text-center">
                                {item.description}
                              </td>{' '}
                              <td className="w-10 border-b p-3 text-[14px]   text-center">
                                {item.projectName}
                              </td>{' '}
                              <td className="w-10 border-b p-3 text-[14px] text-center">
                                <select
                                  onChange={(e) =>
                                    ChangeUserPermissionStatus(
                                      e,
                                      item.permissionId,
                                    )
                                  }
                                  className="w-full border p-1 rounded-md"
                                >
                                  <option value={null}></option>
                                  {item.isActive ? (
                                    <option selected value={true}>
                                      فعال
                                    </option>
                                  ) : (
                                    <option value={true}>فعال</option>
                                  )}{' '}
                                  {!item.isActive ? (
                                    <option selected value={false}>
                                      غیر فعال
                                    </option>
                                  ) : (
                                    <option value={false}>غیر فعال</option>
                                  )}
                                </select>
                                {/* {item.isActive ? (
                                  <span className="w-full flex items-center justify-center">
                                    فعال
                                  </span>
                                ) : (
                                  <span className="w-full flex items-center justify-center">
                                    غیر فعال
                                  </span>
                                )} */}
                              </td>
                              <td className="w-10 border-b p-3 text-[14px] text-center">
                                <span className="w-full flex items-center justify-center">
                                  <button
                                    onClick={() =>
                                      RemovePermissionFromUser(
                                        item.permissionId,
                                      )
                                    }
                                    className="group relative flex h-10 w-10 flex-col items-center justify-center overflow-hidden rounded-xl border-2 border-[#991b1b] bg-[#f87171] hover:bg-[#dc2626]"
                                  >
                                    <svg
                                      viewBox="0 0 1.625 1.625"
                                      className="absolute -top-7 fill-white delay-100 group-hover:top-6 group-hover:animate-[spin_1.4s] group-hover:duration-1000"
                                      height="8"
                                      width="8"
                                    >
                                      <path d="M.471 1.024v-.52a.1.1 0 0 0-.098.098v.618c0 .054.044.098.098.098h.487a.1.1 0 0 0 .098-.099h-.39c-.107 0-.195 0-.195-.195"></path>
                                      <path d="M1.219.601h-.163A.1.1 0 0 1 .959.504V.341A.033.033 0 0 0 .926.309h-.26a.1.1 0 0 0-.098.098v.618c0 .054.044.098.098.098h.487a.1.1 0 0 0 .098-.099v-.39a.033.033 0 0 0-.032-.033"></path>
                                      <path d="m1.245.465-.15-.15a.02.02 0 0 0-.016-.006.023.023 0 0 0-.023.022v.108c0 .036.029.065.065.065h.107a.023.023 0 0 0 .023-.023.02.02 0 0 0-.007-.016"></path>
                                    </svg>
                                    <svg
                                      width="16"
                                      fill="none"
                                      viewBox="0 0 39 7"
                                      className="origin-right duration-500 group-hover:rotate-90"
                                    >
                                      <line
                                        stroke-width="4"
                                        stroke="white"
                                        y2="5"
                                        x2="39"
                                        y1="5"
                                      ></line>
                                      <line
                                        stroke-width="3"
                                        stroke="white"
                                        y2="1.5"
                                        x2="26.0357"
                                        y1="1.5"
                                        x1="12"
                                      ></line>
                                    </svg>
                                    <svg
                                      width="16"
                                      fill="none"
                                      viewBox="0 0 33 39"
                                      className=""
                                    >
                                      <mask
                                        fill="white"
                                        id="path-1-inside-1_8_19"
                                      >
                                        <path d="M0 0H33V35C33 37.2091 31.2091 39 29 39H4C1.79086 39 0 37.2091 0 35V0Z"></path>
                                      </mask>
                                      <path
                                        mask="url(#path-1-inside-1_8_19)"
                                        fill="white"
                                        d="M0 0H33H0ZM37 35C37 39.4183 33.4183 43 29 43H4C-0.418278 43 -4 39.4183 -4 35H4H29H37ZM4 43C-0.418278 43 -4 39.4183 -4 35V0H4V35V43ZM37 0V35C37 39.4183 33.4183 43 29 43V35V0H37Z"
                                      ></path>
                                      <path
                                        stroke-width="4"
                                        stroke="white"
                                        d="M12 6L12 29"
                                      ></path>
                                      <path
                                        stroke-width="4"
                                        stroke="white"
                                        d="M21 6V29"
                                      ></path>
                                    </svg>
                                  </button>
                                </span>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                )}
                <div className="w-full px-5 py-2 flex flex-col">
                <button className="BtnAdd"  onClick={() => {
                      GetPermissionList();
                      setOpenModal((prev) => ({
                        ...prev,
                        ShowPermissionsSelect: true,
                      }));
                    }}>
  
  <div className="sign">+</div>
  
  <div className="text font-IranSans  text-[14px] mr-5">افزودن مجوز</div>
</button>
                  {/* <button
                    className="font-IranSans w-40 text-[14px] border p-2 rounded-md"
                   
                  >
                    ایجاد مجوز{' '}
                  </button> */}
                  <div className="mt-7 flex w-full items-center justify-between">
                    {openModal.ShowPermissionsSelect && (
                      <>
                        <select
                          onChange={(e) => AddPermissionToUser(e)}
                          className="border p-1 rounded-md w-full"
                        >
                          <option></option>
                          {PermissionsSelect.map((per) => {
                            return (
                              <option value={per.id}>{per.claimValue}</option>
                            );
                          })}
                        </select>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {UserRolesListModal && (
          <>
            <div className="ModalBackground">
              <div className="Modal-innerEditUser">
                <FaRegWindowClose
                  onClick={() => {setUserRolesListModal(false);setOpenAddNewRole(!OpenAddNewRole);}}
                  className="mb-2"
                  size={20}
                />
                <div className="w-full h-full">
                  <table className="overflow-auto w-full">
                    <thead>
                      <tr className="font-IranSans w-full bg-[#B1B2FF] text-[#030637]">
                        <th className="w-5 border-b p-3 text-[14px] text-center">
                          ردیف
                        </th>
                        <th className="w-32 border-b p-3 text-[14px] text-center">
                          نام نقش
                        </th>
                        <th className="w-10 border-b p-3 text-[14px] text-center">
                          وضعیت نقش
                        </th>{' '}
                        <th className="w-10 border-b p-3 text-[14px] text-center">
                          حذف
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {UserRolesList.map((item) => {
                        return (
                          <>
                            <>
                              <tr className="cursor-pointer w-full">
                                <td className="w-5 border-b p-3 text-[14px] text-center">
                                  {(rowNumber = rowNumber + 1)}
                                </td>
                                <td className="w-40 border-b p-3 text-[14px]   text-center">
                                  {item.description}
                                </td>{' '}
                                <td className="w-10 border-b p-3 text-[14px] text-center">
                                  {item.isActive ? (
                                    <span className="w-full flex items-center justify-center">
                                      فعال
                                    </span>
                                  ) : (
                                    <span className="w-full flex items-center justify-center">
                                      غیر فعال
                                    </span>
                                  )}
                                </td>
                                <td className="w-10 border-b p-3 text-[14px] text-center">
                                  <span className="w-full flex items-center justify-center">
                                    <button
                                      onClick={() =>
                                        RemoverRoleFromUser(item.name)
                                      }
                                      className="group relative flex h-10 w-10 flex-col items-center justify-center overflow-hidden rounded-xl border-2 border-[#991b1b] bg-[#f87171] hover:bg-[#dc2626]"
                                    >
                                      <svg
                                        viewBox="0 0 1.625 1.625"
                                        className="absolute -top-7 fill-white delay-100 group-hover:top-6 group-hover:animate-[spin_1.4s] group-hover:duration-1000"
                                        height="8"
                                        width="8"
                                      >
                                        <path d="M.471 1.024v-.52a.1.1 0 0 0-.098.098v.618c0 .054.044.098.098.098h.487a.1.1 0 0 0 .098-.099h-.39c-.107 0-.195 0-.195-.195"></path>
                                        <path d="M1.219.601h-.163A.1.1 0 0 1 .959.504V.341A.033.033 0 0 0 .926.309h-.26a.1.1 0 0 0-.098.098v.618c0 .054.044.098.098.098h.487a.1.1 0 0 0 .098-.099v-.39a.033.033 0 0 0-.032-.033"></path>
                                        <path d="m1.245.465-.15-.15a.02.02 0 0 0-.016-.006.023.023 0 0 0-.023.022v.108c0 .036.029.065.065.065h.107a.023.023 0 0 0 .023-.023.02.02 0 0 0-.007-.016"></path>
                                      </svg>
                                      <svg
                                        width="16"
                                        fill="none"
                                        viewBox="0 0 39 7"
                                        className="origin-right duration-500 group-hover:rotate-90"
                                      >
                                        <line
                                          stroke-width="4"
                                          stroke="white"
                                          y2="5"
                                          x2="39"
                                          y1="5"
                                        ></line>
                                        <line
                                          stroke-width="3"
                                          stroke="white"
                                          y2="1.5"
                                          x2="26.0357"
                                          y1="1.5"
                                          x1="12"
                                        ></line>
                                      </svg>
                                      <svg
                                        width="16"
                                        fill="none"
                                        viewBox="0 0 33 39"
                                        className=""
                                      >
                                        <mask
                                          fill="white"
                                          id="path-1-inside-1_8_19"
                                        >
                                          <path d="M0 0H33V35C33 37.2091 31.2091 39 29 39H4C1.79086 39 0 37.2091 0 35V0Z"></path>
                                        </mask>
                                        <path
                                          mask="url(#path-1-inside-1_8_19)"
                                          fill="white"
                                          d="M0 0H33H0ZM37 35C37 39.4183 33.4183 43 29 43H4C-0.418278 43 -4 39.4183 -4 35H4H29H37ZM4 43C-0.418278 43 -4 39.4183 -4 35V0H4V35V43ZM37 0V35C37 39.4183 33.4183 43 29 43V35V0H37Z"
                                        ></path>
                                        <path
                                          stroke-width="4"
                                          stroke="white"
                                          d="M12 6L12 29"
                                        ></path>
                                        <path
                                          stroke-width="4"
                                          stroke="white"
                                          d="M21 6V29"
                                        ></path>
                                      </svg>
                                    </button>
                                  </span>
                                </td>
                                {/* <td className="w-10 border-b p-3 text-[14px] text-center">
                                        <span className="w-full flex items-center justify-center">
                                          <Link
                                            to={`/RolePermission/${item.id}/${item.description}/${item.name}`}
                                          >
                                            <button
                                              className="edit-button"
                                              // onClick={() => GetPermissionList(item.id,item.description)}
                                            >
                                              <RiShieldKeyholeLine
                                                size={35}
                                                className="edit-svgIcon"
                                              />
                                            </button>
                                          </Link>
                                        </span>
                                      </td> */}
                              </tr>
                            </>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                  <div className="w-full mt-7 flex flex-col px-5">
                  <button className="BtnAdd"   onClick={() => {
                        setOpenAddNewRole(!OpenAddNewRole);
                      }}>
  
  <div className="sign">+</div>
  
  <div className="text font-IranSans  text-[14px] mr-5"> افزودن نقش</div>
</button>
                    {/* <button
                      className="font-IranSans text-[14px] border rounded-md p-2 w-40"
                     
                    >
                      افزودن نقش جدید
                    </button> */}
                    {OpenAddNewRole && (
                      <>
                        <div className="mt-5">
                          <select
                            onChange={(e) => setUserRole(e.target.value)}
                            className="w-full border rounded-md p-1"
                          >
                            {Roles.map((role) => {
                              return (
                                <option value={role.name}>
                                  {role.description}
                                </option>
                              );
                            })}
                          </select>
                          <div className="w-full ltr mt-3 ">
                          <button className='RoleBtn text-[14px]'  onClick={AddRoleToUserFun}>افزودن</button>

                            {/* <button
                             
                              className="w-40 border rounded-full text-[14px] p-1 font-IranSans"
                            >
                              
                            </button> */}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default UsersManagment;
